import { VENDORS_PORTAL_API_URL } from 'src/constants/urls';
import { Orders, NewOrderDetails } from '../pages';
import { ENABLE_NEW_ORDERS_PAGE } from '../utils/featureFlags';

const redirectToNewOrdersPage = () => {
  window.location.replace(`${VENDORS_PORTAL_API_URL}/pedidos`);
  return null;
};

export const OrderManagementRoutes = [
  {
    path: '/pedido/details-v2/:id',
    isPrivate: true,
    component: <NewOrderDetails />,
  },
  {
    path: '/pedido',
    exact: true,
    isPrivate: true,
    component: ENABLE_NEW_ORDERS_PAGE ? redirectToNewOrdersPage : <Orders />,
  },
];
